module.exports = __webpack_public_path__ + "img/partB3.caa61408.png";